const dbRequest = require("../../../../../js-network/db-request");
const multitable = require("../../../../../components/multitable/multitable");
const snack = require("../../../../../components/snack/snack");
const fullcontFormHandler = require("../../../../../components/fullcont/fullcont-form-handler");
const textfieldHandler = require("../../../../../components/textfield/textfield-handler");
const sentpaymentDialog = require('./sentpayment-dialog')
const sentpaymentCheckQuickform = require('./sentpayment-check-quickform')
const sentpaymentReport = require('./sentpayment-report')
const sentpaymentSnack = require('./sentpayment-snack')

// Palabras en inglés usadas por el convertidor. Se mantienen locales a sentpayment.
const amountUnits = [
  'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
  'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
  'Seventeen', 'Eighteen', 'Nineteen'
]
const amountTens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety']
const amountScales = ['', 'Thousand', 'Million', 'Billion', 'Trillion', 'Quadrillion']
const checkGenerationFieldNames = ['check_status', 'check_amount', 'check_memo']

// Convierte un grupo de 1 a 999. Los números mayores se dividen en estos grupos.
function hundredsToWords(value) {
  const words = []
  const hundreds = Math.floor(value / 100)
  const remainder = value % 100

  if (hundreds > 0) {
    words.push(amountUnits[hundreds], 'Hundred')
  }

  if (remainder > 0 && remainder < 20) {
    words.push(amountUnits[remainder])
  } else if (remainder >= 20) {
    words.push(amountTens[Math.floor(remainder / 10)])

    if (remainder % 10 > 0) {
      words.push(amountUnits[remainder % 10])
    }
  }

  return words.join(' ')
}

// Convierte la parte entera en grupos de tres dígitos: miles, millones, billones, etc.
function integerToWords(value) {
  if (value === 0) { return amountUnits[0] }

  const words = []
  let remainder = value
  let scaleIndex = 0

  while (remainder > 0) {
    const group = remainder % 1000

    if (group > 0) {
      const groupWords = hundredsToWords(group)
      const scale = amountScales[scaleIndex]
      words.unshift(scale === '' ? groupWords : `${groupWords} ${scale}`)
    }

    remainder = Math.floor(remainder / 1000)
    scaleIndex++
  }

  return words.join(' ')
}

/**
 * Convierte un importe numérico no negativo al texto usado en un cheque.
 * Redondea la parte decimal a dos dígitos y la expresa como centavos sobre 100.
 * Ejemplo: 1250.75 -> "ONE THOUSAND TWO HUNDRED FIFTY AND 75/100".
 * Devuelve una cadena vacía si el valor está vacío, es inválido, negativo o queda
 * fuera del rango entero seguro de JavaScript después de convertirlo a centavos.
 */
export function amountToWords(amount) {
  if (amount === null || amount === undefined || String(amount).trim() === '') { return '' }

  const numericAmount = Number(amount)

  if (!Number.isFinite(numericAmount) || numericAmount < 0) {
    return ''
  }

  // Trabaja con centavos enteros para evitar arrastrar decimales de punto flotante.
  const totalCents = Math.round((numericAmount + Number.EPSILON) * 100)

  if (!Number.isSafeInteger(totalCents)) { return '' }

  const integerAmount = Math.floor(totalCents / 100)
  const cents = String(totalCents % 100).padStart(2, '0')

  return `${integerToWords(integerAmount)} and ${cents}/100`.toUpperCase()
}

/**
 * Sincroniza el importe principal del sentpayment con el importe en letras del cheque.
 * Solo escribe cuando Check generation está activo, para no crear datos de cheque
 * en pagos normales. El helper de textfield también mantiene correcto el estado del label.
 */
export function updateCheckAmount(htmlFc) {
  const checkbox = htmlFc.fullcontHTML.querySelector('#sentpayment_form_check_generation_active input')
  const amountInput = htmlFc.fullcontHTML.querySelector('#sentpayment_form_amount input')
  const checkAmountField = htmlFc.fullcontHTML.querySelector('#sentpayment_form_check_amount')

  if (checkbox === null || amountInput === null || checkAmountField === null || !checkbox.checked) { return }

  const amountInWords = amountToWords(amountInput.value)

  if (amountInWords === '') {
    textfieldHandler.clean(checkAmountField)
    return
  }

  textfieldHandler.fill(checkAmountField, amountInWords)
}

/**
 * Limpia del formulario los datos opcionales del cheque cuando el checkbox está
 * desmarcado. check_date se conserva porque siempre replica la fecha del pago.
 */
function clearCheckGenerationFields(htmlFc, syncFormCopy = false) {
  htmlFc.form.forEach((field) => {
    if (!checkGenerationFieldNames.includes(field.name)) { return }

    field.value = ''
    fullcontFormHandler.clean(field)

    if (syncFormCopy) {
      const fieldCopy = htmlFc.formCopy.find((copy) => copy.name === field.name)

      if (fieldCopy !== undefined) {
        fieldCopy.value = ''
      }
    }
  })
}

/**
 * Selecciona Generated al activar la generaciÃ³n de cheque si el usuario todavÃ­a
 * no ha elegido otro estado. No reemplaza el estado de un cheque ya existente.
 */
function setDefaultCheckStatus(htmlFc) {
  const checkStatusField = htmlFc.form.find((field) => field.name === 'check_status')
  const selectedStatus = checkStatusField?.html?.querySelector('select')?.value ?? ''

  if (checkStatusField === undefined || selectedStatus !== '') { return }

  checkStatusField.value = 'Generated'
  fullcontFormHandler.fill(checkStatusField)
}

/**
 * El componente general agrega una opcion vacia `Select`. El estado del cheque
 * no debe mostrarla, por lo que sentpayment la elimina sin cambiar el contrato
 * de los demas multiselect. Si el valor interno esta vacio se conserva una
 * seleccion real vacia para no registrar cambios al cerrar un alta intacta.
 */
function removeCheckStatusEmptyOption(htmlFc) {
  const checkStatusField = htmlFc.form.find((field) => field.name === 'check_status')
  const select = checkStatusField?.html?.querySelector('select')

  if (select === null || select === undefined) { return }

  const emptyOption = Array.from(select.options).find((option) => option.value === '')

  if (emptyOption !== undefined) {
    emptyOption.remove()
  }

  if (checkStatusField.value === '') {
    select.selectedIndex = -1
  }
}

/**
 * Copia Payment Date a la fecha del cheque, incluso cuando el card está oculto.
 * El backend repite esta sincronización para que el valor guardado no dependa del DOM.
 */
export function syncCheckDate(htmlFc, syncFormCopy = false) {
  const paymentDateInput = htmlFc.fullcontHTML.querySelector('#sentpayment_form_date input')
  const checkDateField = htmlFc.form.find((field) => field.name === 'check_date')

  if (paymentDateInput === null || checkDateField === undefined) { return }

  checkDateField.value = paymentDateInput.value === '' ? '0000-00-00' : paymentDateInput.value

  if (paymentDateInput.value === '') {
    fullcontFormHandler.clean(checkDateField)
  } else {
    textfieldHandler.fill(checkDateField.html, paymentDateInput.value)
  }

  if (syncFormCopy) {
    const checkDateCopy = htmlFc.formCopy.find((field) => field.name === 'check_date')

    if (checkDateCopy !== undefined) {
      checkDateCopy.value = checkDateField.value
    }
  }
}

export function toggleCheckGeneration(htmlFc, fromUserChange = false) {
  const checkbox = htmlFc.fullcontHTML.querySelector('#sentpayment_form_check_generation_active input');
  const card = htmlFc.fullcontHTML.querySelector('#sentpayment_check_generation_card');

  if (checkbox === null || card === null) { return; }

  syncCheckDate(htmlFc, !fromUserChange)

  if (checkbox.checked) {
    card.classList.remove('dn');

    if (fromUserChange) {
      setDefaultCheckStatus(htmlFc)
      updateCheckAmount(htmlFc)
    }
  } else {
    card.classList.add('dn');
    clearCheckGenerationFields(htmlFc, !fromUserChange)
  }

  removeCheckStatusEmptyOption(htmlFc)
}

export function getAllInvoice(detail, htmlFc) {
  //console.log('updateCsutomerField -> ', htmlFc)

  let input_customer = htmlFc.fullcontHTML.querySelector(
    "#sentpayment_form_provider_id"
  );
  let input_selected = input_customer.getAttribute("selected");

  if (JSON.parse(input_selected).length > 0) {
    load(detail, JSON.parse(input_selected)[0], htmlFc);
  }
}

export function addAmount(detail, htmlFc) {
  // Inicializar el total
  let total_due_amount = 0;
  let total_sent_amount = 0;

  // Obtener todos los checkbox de las filas
  const checkboxes = htmlFc.fullcontHTML.querySelectorAll("#sentpayment_form_mt_" + detail.line + " input[type='checkbox']");
  // Obtener todas las filas
  const inputs = htmlFc.fullcontHTML.querySelectorAll("#sentpayment_form_payment_vs_po_or_services .line");

  // Obtener el elemento del formulario donde se mostrará el total
  const div_amount_fc = htmlFc.fullcontHTML.querySelector("#sentpayment_form_amount .elem");

  // Iterar sobre cada checkbox
  checkboxes.forEach((checkbox) => {
    // Si el checkbox está seleccionado, sumar el valor correspondiente
    if (checkbox.checked) {
      const row = checkbox.closest("#sentpayment_form_mt_" + detail.line);
      const due_amount_elem = row.querySelector(".due_amount .elem");

      // Obtener el valor de due_amount y sumarlo al total_due_amount
      const due_amount = parseFloat(due_amount_elem.value) || 0;
      total_due_amount += due_amount;
    }
  });

  // Mostrar el total de due_amount en el input correspondiente (opcional)
  const div_sent_amount = htmlFc.fullcontHTML.querySelector("#sentpayment_form_mt_" + detail.line + " .sent_amount .elem");
  div_sent_amount.value = total_due_amount;

  // Sumar todos los valores de los inputs sent_amount
  inputs.forEach((line) => {
    const input_sent = line.querySelector(".sent_amount .elem");
    if (input_sent) {
      total_sent_amount += parseFloat(input_sent.value) || 0;
    }
  });

  // Mostrar el total en el input correspondiente
  div_amount_fc.value = total_sent_amount;
  updateCheckAmount(htmlFc)

  // Para depuración
  //console.log("Total due amount:", total_due_amount);
  //console.log("Total final de sent amount:", total_sent_amount);
}

export function getAllInvoiceExpenses(detail, htmlFc) {
  //console.log('updateCsutomerField -> ', htmlFc)

  let input_customer = htmlFc.fullcontHTML.querySelector(
    "#sentpayment_form_provider_id"
  );
  let input_selected = input_customer.getAttribute("selected");

  if (JSON.parse(input_selected).length > 0) {
    loadExpenses(detail, JSON.parse(input_selected)[0], htmlFc);
  }
}

const load = (detail, value, htmlFc) => {
  return loadDB(detail, value)
    .then((result) => {
      //console.log("pruera");

      //the entity was deleted
      if (result.multiTables[0] === undefined) {
        snack.start({ act: "show", id: "noInvoicePending" });
        multitable.start({ act: "clean", entityMT: htmlFc.entityMT });
        return;
      } /**/

      multitable.start({
        act: "loadResultToForm",
        entityMT: htmlFc.entityMT,
        resultMT: result.multiTables,
      });

      multitable.start({ act: "generator_insert", entityMT: htmlFc.entityMT });
    })
    .catch((error) => {
      throw error;
      //console.log("Error Getting Invoice", error);
    });
}; /**/

async function loadDB(detail, value) {
  detail.inf = { purchase_id: value };

  ///yeison/php/settings.php
  //const result = await dbRequest.start(detail, 'php/settings.php' ) //do the insert
  const result = await dbRequest.start(
    detail,
    "server/php/sql/getAllPurchase.php"
  ); //do the insert

  if (result.status != "ok") {
    throw result;
  }

  return result;
}

export function verifyMultitable(detail, htmlFc) {
  const checkGeneration = htmlFc.fullcontHTML.querySelector('#sentpayment_form_check_generation_active input')

  syncCheckDate(htmlFc)

  // Defensa previa al guardado: un pago sin cheque nunca envía datos residuales del card.
  if (checkGeneration !== null && !checkGeneration.checked) {
    clearCheckGenerationFields(htmlFc)
  }

  let allInvoice = htmlFc.fullcontHTML.querySelectorAll(
    "#sentpayment_form_payment_vs_po_or_services  .line"
  );

  let allInputsEmpty = true;
  let totalAmountSent = 0;
  let input_amount = htmlFc.fullcontHTML.querySelector(
    "#sentpayment_form_amount input"
  );

  //let error= false;

  for (const line of allInvoice) {
    let input_sent = line.querySelector(".sent_amount input");

    if (/^(?:[1-9]\d*|0)?(?:\.\d+)?$/.test(input_sent.value) == false) {
      snack.start({ act: "show", id: "invalidValue" });
      textfieldHandler.error(input_sent.closest(".textfield"));
      return false;
    }

    if (input_sent.value.trim() != "" && parseFloat(input_sent.value) != 0) {
      allInputsEmpty = false;
    }

    if (input_sent.value.trim() != "") {
      input_sent.value = parseFloat(input_sent.value);
      totalAmountSent = totalAmountSent + parseFloat(input_sent.value);
    }
  }

  if (allInputsEmpty == true) {
    snack.start({ act: "show", id: "fillInvoiceRequired" });

    allInvoice.forEach(function (line) {
      let input_sent = line.querySelector(".sent_amount input");
      textfieldHandler.error(input_sent.closest(".textfield"));
    });

    return false;
  }

  if (parseFloat(input_amount.value) != totalAmountSent) {
    snack.start({ act: "show", id: "valueEqual" });
    textfieldHandler.error(input_amount.closest(".textfield"));
    return false;
  }

  allInvoice.forEach(function (line) {
    let input_sent = line.querySelector(".sent_amount input");

    if (input_sent.value.trim() == "" || parseFloat(input_sent.value) == 0) {
      line.remove();
    }
  });

  return true;
}

export function validated_press(detail, htmlFc) {
  let input_sent = detail.ev.target;

  if (/^\d+(\.\d+)?$/.test(input_sent.value) == true) {
    textfieldHandler.errorClean(input_sent.closest(".textfield"));
  }
}

// print pdf
export function reportPdf(detail, htmlFc, callback) {
  const detailId = String(detail.id ?? '').trim()
  const dbid = htmlFc.fullcontHTML.getAttribute('data-dbid')
  const id = detailId !== '' ? detailId : dbid

  if (!id) { return }

  const checkGenerationInput = htmlFc.fullcontHTML.querySelector(
    '#sentpayment_form_check_generation_active input'
  )
  const usesCheck = detail.checkGenerationActive !== undefined
    ? detail.checkGenerationActive === true || detail.checkGenerationActive === 'true'
    : checkGenerationInput?.checked === true
  const report = detail.report || (usesCheck ? 'sentpayment-check' : 'sentpayment-one')

  if (report === 'sentpayment-check' && !usesCheck) {
    sentpaymentDialog.start({ act: 'show', id: 'checkGenerationDisabled' })
    return
  }

  if (report === 'sentpayment-check') {
    // Todo punto de impresion de cheques pasa por la misma vista previa.
    sentpaymentCheckQuickform.start({ act: 'preparePrint', ids: [id], afterMarked: callback })
    return
  }

  sentpaymentReport.printPdf({
    id: id,
    type: 'print',
    entity: detail.entity || 'sentpayment',
    report: report,
  })
}

function printPdf(data, callback) {
  const formData = new FormData();
  formData.append('id', data.id);
  formData.append('type', data.type);
  formData.append('entity', data.entity);
  formData.append('reportName', data.report);
  const isPdf = true;

  const controller = new AbortController();
  const timeout = setTimeout(() => { controller.abort() }, 30000);

  let options = {
    method: 'POST',
    body: formData,
    signal: controller.signal,
    credentials: 'same-origin'
  };

  // fetch(`./server/php/queries/report/sentpayment/pdf-invoice.php`, options)
  fetch(`./server/php/report/report-pdf.php`, options)
    .then(async (response) => {
      const contentType = response.headers.get('content-type') || ''

      if (contentType.includes('application/json')) {
        const result = await response.json()

        if (data.report === 'sentpayment-check') {
          const checkDialogIds = [
            'checkPaymentNotFound',
            'checkGenerationDisabled',
            'checkBankInformationDisabled',
            'checkAccountNumberMissing',
            'checkRoutingNumberInvalid',
            'missingDefaultCheckSignature'
          ]
          const errorId = result.error?.val
          const dialogId = checkDialogIds.includes(errorId) ? errorId : 'checkPrintError'

          sentpaymentDialog.start({ act: 'show', id: dialogId })
          return null
        }

        throw new Error('report-pdf')
      }

      if (!response.ok || !contentType.includes('application/pdf')) {
        throw new Error('report-pdf')
      }
      // 1. Cambiamos .text() por .blob() para manejar el binario del PDF correctamente

      return {
        blob: await response.blob(),
        checkWasPrinted: response.headers.get('x-check-status') === 'Printed'
      };
    })
    .then((pdfResult) => {
      if (pdfResult === null) { return }

      const blob = pdfResult.blob

      if (isPdf) {
        // --- LÓGICA PARA PDF ---
        const pdfBlob = new Blob([blob], { type: "application/pdf" });
        const fileUrl = URL.createObjectURL(pdfBlob);
        const newTab = window.open(fileUrl, "_blank");

        if (newTab) {
          newTab.addEventListener('load', () => {
            URL.revokeObjectURL(fileUrl);
          }, { once: true });
        }

        // Solo la confirmacion del servidor cambia el estado del cheque.
        if (pdfResult.checkWasPrinted && typeof callback === 'function') {
          callback(data)
        }
      } else {
        // --- LÓGICA PARA CSV ---
        // Se define el MIME type para CSV
        const csvBlob = new Blob([blob], { type: "text/csv;charset=utf-8;" });
        const fileUrl = URL.createObjectURL(csvBlob);

        // Creamos un enlace temporal en el DOM
        const tempLink = document.createElement("a");
        tempLink.href = fileUrl;

        // Asignamos un nombre de archivo por defecto (puedes personalizarlo)
        tempLink.setAttribute("download", `report_${new Date().getTime()}.csv`);
        tempLink.style.display = "none";

        document.body.appendChild(tempLink);
        tempLink.click(); // Disparamos la descarga

        // Limpiamos el DOM y liberamos la memoria
        document.body.removeChild(tempLink);
        URL.revokeObjectURL(fileUrl);
      }
    })
    // .then(response => {
    //   if (!response.ok) {
    //     alert("An error occurred while printing the PDF. Please try again.");
    //   } else {
    //     return response.text(); // Devolver el nombre del archivo PDF generado
    //   }
    // })
    // .then(pdfFileName => {
    //   if (pdfFileName) {
    //     // Ruta base del servidor
    //     const baseUrl = 'https://beestock.gosive.com/server/server/';

    //     // Agregar la parte faltante a la ruta del PDF
    //     const fullPath = pdfFileName.startsWith('server/') ? pdfFileName : 'server/' + pdfFileName;

    //     // Construir la URL absoluta del archivo PDF
    //     const realPdfUrl = new URL(fullPath, baseUrl).href;

    //     // Crear un iframe para cargar el PDF generado
    //     const iframe = document.createElement("iframe");
    //     iframe.style.display = "none";
    //     iframe.src = realPdfUrl;
    //     document.body.appendChild(iframe);

    //     // Esperar a que el PDF se cargue en el iframe antes de imprimir
    //     iframe.contentWindow.print();

    //     //console.log(realPdfUrl)

    //   }
    // })
    .catch(() => {
      if (data.report === 'sentpayment-check') {
        sentpaymentDialog.start({ act: 'show', id: 'checkPrintError' })
        return
      }

      snack.start({ act: 'show', id: 'downloadError' })
    })
    .finally(() => {
      clearTimeout(timeout)
    })
}


//verificar si el sent payment contiene una compra con credito 
export async function verifySentHasPurchaseWithCredit(dbid, htmlFc) {
  let data = { id: dbid };
  const formData = new FormData();
  formData.append('sent_payment_id', data.id);

  const controller = new AbortController();
  const timeout = setTimeout(() => { controller.abort() }, 30000);

  let options = {
    method: 'POST',
    body: formData,
    signal: controller.signal,
    credentials: 'same-origin'
  };

  try {
    const result = await fetch(`./server/php/sql/getPurchasesHasCredit.php`, options);
    const sentData = await result.json();

    if (sentData.restriction.val == "PurchaseHasCredit") {
      sentpaymentSnack.start({ act: 'show', id: 'somePurchaseHasCredit' });
      return false;
    } else {
      return true;
    }

  } catch (error) {
    throw error;
  } finally {
    clearTimeout(timeout);
  }
  return false;
}



// bloquea las lineas del MT que contienen Purchase que tienen credito o credito gastado, los COGS no se bloquean
export function blockPurchaseHasCredit(data, htmlFc) {
  //contiene los datos Purchases usados en el receive payment
  let purchaseUsed = JSON.parse(data.purchase_used)[0].data;
  let ifPurchaseCredit = false;

  //busca todas las lineas del mt
  let lines = htmlFc.fullcontHTML.querySelectorAll("#sentpayment_form_payment_vs_po_or_services  .line");
  lines.forEach(line => {
    let ac_purchase = line.querySelector(".expense_id")
    let purchase_selected = ac_purchase.getAttribute("selected");
    purchase_selected = JSON.parse(purchase_selected);
    let purcahseOtherField = get_otherField(ac_purchase);

    if (purchase_selected.length > 0) {
      let purchase_id = purchase_selected[0];

      for (let index = 0; index < purchaseUsed.length; index++) {
        //validar que el purchase de la linea del mt este en los purchases usados y que no sean COGS
        if (purchaseUsed[index].purchase_id == purchase_id && purcahseOtherField.type.toUpperCase() != "COGS") {
          //si el purchase usado tiene credito o credito gastado bloquear la linea
          if (parseFloat(purchaseUsed[index].spent_credit) > 0) {
            line.classList.add('multitable-line-blocked');
            line.setAttribute("data-detail", '{"click":   [ {"dest":"textfield", "act":"restriction"  }] }');
            ifPurchaseCredit = true;
            break;
          }
        }
      }
    }
  });

  if (ifPurchaseCredit) {
    sentpaymentSnack.start({ act: 'show', id: 'somePurchaseHasCredit' });
  }

}



export function get_otherField(ac_line) {
  try {

    let rawFields = ac_line.querySelector(".otherField");

    if (rawFields == null) {
      throw "Null";
    }

    return JSON.parse(rawFields.getAttribute('otherField'));

  } catch (error) {
    throw error;
    //console.error("Error parsing JSON:", error);
  }
}
